export const AUTH_API = {
    SignIn: 'admin/sign-in'
};

export const PROJECT = {
    NoneOfNft: 'project/none-nft',
    Detail: 'project/detail/'
};

export const NFT = {
    Issue: 'nft/issueNft',
    Detail: 'nft/detail/',
    Extend: 'nft/extend/',
    UpdateRating: 'nft/'
}
